export class History {
    getQueryParam = (key: string): string => {
        const search = window.location.hash.split('?')[1] || '';
        return new URLSearchParams(search).get(key) || '';
    }
}
